export { useProviderDetailsData } from './useProviderDetailsData';
